import CustomButton from "@/components/common/Button";
import { DynamicModuleService } from "@/services/APIs";
import { ProColumns } from "@ant-design/pro-components";
import { Popconfirm } from "antd";
import { Edit2, Trash, Building2 } from "lucide-react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ConfigDynamicTable from "../../../../components/BaseTable/ConfigDynamicTable";
import MMNavigationRoutes from "../../utils/navigationRoutes";
import { Button } from "@/projects/Civi_Circle_Admin/components/ui/button";

const DepartmentListPage = () => {
  const navigate = useNavigate();
  const schemaName = "Add Departments";
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const handleDelete = async (id: string) => {
    await DynamicModuleService.deleteItem(schemaName || "", id);
  };

  const handleEdit = (id: string) => {
    navigate("/mm" + MMNavigationRoutes.EDIT_DEPARTMENT(id));
  };

  const columns: ProColumns<any>[] = [
    {
      title: "Department Name",
      dataIndex: "departmentname",
      render: (_text: any, record) => {
        return (
          <Link to={`/mm${MMNavigationRoutes.EDIT_DEPARTMENT(record.id)}`}>
            {record.departmentname}
          </Link>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone Number",
      dataIndex: "phonenumber",
    },
    {
      title: "Head",
      dataIndex: "head",
    },
    {
      title: "ID",
      dataIndex: "id",
      hidden: true,
    },
    {
      title: "Actions",
      width: 100,
      valueType: "option",
      render: (_, record) => [
        <CustomButton
          key="edit"
          icon={<Edit2 size={16} />}
          onClick={() => handleEdit(record.id)}
          type="text"
        />,
        <Popconfirm
          title="Are you sure you want to delete this Department?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          key="delete"
          cancelText="No"
        >
          <CustomButton
            danger
            key="delete"
            icon={<Trash size={16} />}
            type="text"
          />
        </Popconfirm>,
      ],
    },
  ];

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Departments</h1>
          <p className="mt-2 text-muted-foreground">
            Manage municipal departments and their information
          </p>
        </div>
        <Button
          onClick={() => navigate("/mm" + MMNavigationRoutes.ADD_DEPARTMENT)}
          size="lg"
          className="shadow-lg"
        >
          <Building2 className="mr-2 h-4 w-4" />
          Add Department
        </Button>
      </div>

      {/* Table Section */}
      <div>
        <ConfigDynamicTable<any>
          columns={columns}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          rowKey="id"
          toolBarRender={() => []}
          headerTitle={`Departments`}
          tableName={schemaName || ""}
          filter={
            {
              // Add filters here if needed
            }
          }
        />
      </div>
    </div>
  );
};

export default DepartmentListPage;
